<app-page pageTitle="Standby Plan">
  <div class="standby-plan-page">
    <div class="header rounded-sm">
      <div class="header-item">Date</div>
      <div class="header-item">VMAX</div>
      <div class="header-item">PROJ</div>
      <div class="header-item">IMAX</div>
    </div>
    <app-plan-table class="width-100 flex-1" [planKey]="1" />
    <div class="flex gap-05 width-100">
      <app-button
        class="width-100"
        label="Options"
        [outlined]="globalService.theme() === 'dark'"
        [disabled]="globalService.offline()"
        (click)="onOptionsPress()"
      />
    </div>
  </div>
</app-page>
